import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { auth } from "./services/iam/auth";

sessionStorage.setItem("IS::FIRST::ENTRY", "yes");
localStorage.removeItem("IS::LOGOUT");
sessionStorage.removeItem('ONIDLE::INACTIVITY');

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const renderApp:(info:{
  username: string
  lastname:string,
  expires_in: number;
  timeToExpire: number;
  tenantId: string;
  tokenExpireTime: number;
  sessionTimeOut: number;
  userId: string;
})=>void = (info={username:'',lastname:'', expires_in:300, timeToExpire:120, tenantId:'', tokenExpireTime:60, sessionTimeOut:60, userId:''}) => {
  return root.render(<App info={info} />)
}
auth.initIam(renderApp);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
